(function () {
  if (window.__megaMenuHoverInit) return;
  window.__megaMenuHoverInit = true;

  function swapImage(link) {
    const menu = link.closest('.mega-menu__content');
    if (!menu) return;
    const img = menu.querySelector('.subMenuFeature__image');
    if (!img || !link.dataset.megaImage) return;
    if (img.src === link.dataset.megaImage) return;
    img.src = link.dataset.megaImage;
  }

  function resetImage(menu) {
    const img = menu.querySelector('.subMenuFeature__image');
    if (img && img.dataset.defaultImage) {
      img.src = img.dataset.defaultImage;
    }
  }

  document.addEventListener('mouseover', (event) => {
    const link = event.target.closest('.mega-menu__link[data-mega-image]');
    if (link) swapImage(link);
  });

  document.addEventListener('focusin', (event) => {
    const link = event.target.closest('.mega-menu__link[data-mega-image]');
    if (link) swapImage(link);
  });

  document.addEventListener('mouseout', (event) => {
    const menu = event.target.closest('.mega-menu__content');
    if (!menu) return;
    if (menu.contains(event.relatedTarget)) return;
    resetImage(menu);
  });
})();